import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    const isLanguageSwitch = location.state && location.state.languageSwitch;
    if (!isLanguageSwitch) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [location.pathname, location.state]);

  return null;
}
